import type { ScriptProperties } from "./ScriptProperties";

export interface ArgoCDGitCommitProperties {
    "Octopus.Action.ArgoCD.CommitMessageSummary": string;
    "Octopus.Action.ArgoCD.CommitMessageDescription": string;
    "Octopus.Action.ArgoCD.CommitMethod": string;
    "Octopus.Action.ArgoCD.PullRequest.Environments": string;
    "Octopus.Action.ArgoCD.PullRequest.EnvironmentsTemplateParameter": string;
    //Deprecated - keeping until we remove the old steps
    "Octopus.Action.ArgoCD.PullRequest.Mode": string;
    "Octopus.Action.ArgoCD.PullRequest.SpecificEnvironments": string;
    "Octopus.Action.ArgoCD.PullRequest.SpecificEnvironmentsTemplateParameter": string;
}

export interface ArgoCDImageUpdateProperties extends ScriptProperties, ArgoCDGitCommitProperties, ArgoCDStepVerificationProperties, ArgoCDSyncProperties {}

export enum GitCommitMethods {
    DirectCommit = "DirectCommit",
    PullRequest = "PullRequest",
    PerEnvironment = "PerEnvironment",
}

export interface ArgoCDSyncProperties {
    "Octopus.Action.ArgoCD.Sync.Mode": string;
    "Octopus.Action.ArgoCD.Sync.Environments": string;
    "Octopus.Action.ArgoCD.Sync.EnvironmentsTemplateParameter": string;
}

export enum ArgoCDSyncModes {
    Disabled = "Disabled",
    AllEnvironments = "AllEnvironments",
    PerEnvironment = "PerEnvironment",
}

export interface ArgoCDStepVerificationProperties {
    "Octopus.Action.ArgoCD.StepVerification.Method": string;
    "Octopus.Action.ArgoCD.StepVerification.Timeout": string | null;
}

export enum StepVerificationMethods {
    CommitCreated = "CommitCreated",
    PullRequestMerged = "PullRequestMerged",
    ArgoCDApplicationHealthy = "ArgoCDApplicationHealthy",
}
